import React from "react";

import StatusDetails from "../../utils/comman/statusDetails";

export default function Aepshead(props) {
  const {
    applyStatus,
    Select,
    stylesofStype,
    txnCategryOption,
    changeTxnCatHandler,
    selectedTxnCat,

    statusOption,
    changeHandler,
    selectedStatus,
    fromDateHandler,
    formDate,
    toDateHandler,
    toDate,
    checkDisable,
    resetApply,
    enterTxnsearch,
    search,
    searchdata,
    clearSearch,
    transactionStatuswithAmount,
  } = props;
  // const percentage = 66;
  let ruppysymble = "\u20B9";
  //console.log("transactionStatuswithAmount", transactionStatuswithAmount);
  const initialValue = 0;
  const sumOfallSatus = transactionStatuswithAmount.reduce(
    (accumulator, currentValue) => accumulator + currentValue?.count,
    initialValue
  );
  //console.log("sumOfallSatus", sumOfallSatus);
  return (
    <div style={{marginTop:'0px'}} class="head">
      {/* <h3>AEPS History</h3> */}

      {/* <span >

</span>  */}
      <div style={{marginTop:'20px'}} class="dropdown fltr">
        <button
          type="button"
          title="Filter"
          class="filter dropdown-toggle"
          id="fillist"
          data-bs-toggle="dropdown"
          data-bs-auto-close="false"
          aria-expanded="false"
        >
          Filter
        </button>
        <div
          class="dropdown-menu dropdown-menu-end"
          id="filterbox"
          aria-labelledby="fillist"
        >
          <form onSubmit={applyStatus}>
            <div className="col-12 col-md-12 mb-2 border-bottom ">
              <div class="form-floating">
                <div className="formselect mb-2">
                  <label>Selected Txn Category</label>
                  <Select
                    className="basic-multi-select"
                    styles={stylesofStype}
                    closeMenuOnSelect={false}
                    components={{
                      IndicatorsContainer: () => null,
                      IndicatorSeparator: () => null,
                    }}
                    isMulti
                    options={txnCategryOption}
                    onChange={changeTxnCatHandler}
                    value={selectedTxnCat}
                    placeholder=" select multiple option"
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-12 mb-2 border-bottom ">
              <div class="form-floating">
                <div className="formselect mb-2">
                  <label>Selected Status</label>
                  <Select
                    className="basic-multi-select"
                    styles={stylesofStype}
                    closeMenuOnSelect={false}
                    components={{
                      IndicatorsContainer: () => null,
                      IndicatorSeparator: () => null,
                    }}
                    isMulti
                    options={statusOption}
                    onChange={changeHandler}
                    value={selectedStatus}
                    placeholder=" select multiple option"
                  />
                </div>
              </div>
            </div>
            <div class="filters">
              <label for="select-state">From Date:</label>
              <input type="date" onChange={fromDateHandler} value={formDate} />
            </div>

            <div class="filters">
              <label for="select-state">To Date:</label>
              <input
                min={formDate}
                type="date"
                onChange={toDateHandler}
                value={toDate}
              />
            </div>

            <div class="fbtn">
              <button
                class="btn"
                type="submit"
                id="btnapply"
                disabled={checkDisable()}
              >
                Apply
              </button>
              <button
                class="btn"
                type="reset"
                id="btnclear"
                onClick={resetApply}
              >
                Clear
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* <div class="dropdown fltr">
              <button type="button" class="filter dropdown-toggle" id="fillist" data-bs-toggle="dropdown" data-bs-auto-close="false" aria-expanded="false">Filter</button>							
              <div class="dropdown-menu dropdown-menu-end" id="filterbox" aria-labelledby="fillist">
                  <form onSubmit={callApiReversalRepoertApi} >	
                      <div class="filters">
                          <label for="select-state">TXN From Date:</label>
                          <input type="date" onChange={txnFromDateHandler} value={formDate}/>
                      </div>
                      
                      <div class="filters">
                          <label for="select-state">TXN To Date:</label>
                          <input min={formDate} type="date" onChange={txnToDateHandler} value={toDate}/>
                      </div>
    <div class="filters">
                          <label for="select-state">Updated From Date:</label>
                          <input type="date" onChange={updatedFromDateHandler} value={updatedFormDate}/>
                      </div>
                      
                      <div class="filters">
                          <label for="select-state">Updated To Date:</label>
                          <input min={formDate} type="date" onChange={updatedToDateHandler} value={updatedToDate}/>
                      </div>
                      <div class="fbtn">
                          <button class="btn"  id="btnapply" type="submit" >Download Reversal Report</button>

                      </div>
                  </form>
              </div>
          </div> */}
      <div style={{marginTop:'20px'}} class="headsearch">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            onChange={(event) => enterTxnsearch(event)}
            placeholder="Search transaction..."
            value={search}
          />
          <button
            class="btn search"
            disabled={search.length <= 3}
            type="button"
            id="txnsrch"
            onClick={searchdata}
          >
            search
          </button>
          <button
            style={{ background: "#FF8D33", marginLeft: "3px" }}
            class="btn delete"
            // disabled={search.length <= 3}
            type="button"
            onClick={clearSearch}
          >
            clear
          </button>
        </div>
      </div>
      {/* <div class="dropdown fltr mr-2">
              <button type="button" title="Revesal Report" style={{border:'2px solid rgb(14 14 14)'}} class="filter dropdown-toggle" id="fillist" data-bs-toggle="dropdown" data-bs-auto-close="false" aria-expanded="false">Filter</button>							
              <div class="dropdown-menu dropdown-menu-end" id="filterbox" aria-labelledby="fillist">
                  <form onSubmit={callApiReversalRepoertApi} >	
                      <div class="filters">
                          <label for="select-state">TXN From Date:</label>
                          <input type="date" onChange={txnFromDateHandler} value={formDate}/>
                      </div>
                      
                      <div class="filters">
                          <label for="select-state">TXN To Date:</label>
                          <input min={formDate} type="date" onChange={txnToDateHandler} value={toDate}/>
                      </div>
    <div class="filters">
                          <label for="select-state">Updated From Date:</label>
                          <input type="date" onChange={updatedFromDateHandler} value={updatedFormDate}/>
                      </div>
                      
                      <div class="filters">
                          <label for="select-state">Updated To Date:</label>
                          <input min={formDate} type="date" onChange={updatedToDateHandler} value={updatedToDate}/>
                      </div>
                      <div class="fbtn">
                          <button class="btn"  id="btnapply" type="submit" disabled={revcheckDisable()} >Download Reversal Report</button>

                      </div>
                  </form>
              </div>
          </div> */}
      {/* <div style={{border:'2px solid red', width:'400px'}}>
            <h4 style={{ width:'100px'}}>hjhjhj</h4>
            
          <div style={{width: '60px', height:'60px', float:'right'}}>
          
        <CircularProgressbar  value={percentage} text={`${percentage}%`} />
        
        </div>
        <h4 style={{ width:'100px'}}>hjhjhj</h4>
        </div> */}
      {/* <div class="parent">
      {transactionStatuswithAmount !== null &&
          transactionStatuswithAmount !== undefined &&
          transactionStatuswithAmount.length > 0 &&
          transactionStatuswithAmount.map((txnstatus, inde)=>{
          {console.log('txnstatus', txnstatus)}
          const percentage = sumOfallSatus == 0 ? 0 : (txnstatus.count *100)/sumOfallSatus
            const statusColor = txnstatus?.id == "SUCCESS" ? "success" : txnstatus?.id == "FAILED"? "danger" : txnstatus?.id == "PENDING"? "warning" : "00FFFF"
            const statusRailColor = txnstatus?.id == "SUCCESS" ? `rgba(25, 135, 84, 1)` : txnstatus?.id == "FAILED"? `rgba(220, 53, 69, 1)` : txnstatus?.id == "PENDING"? `rgba(255, 193, 7, 1)` : "00FFFF"
        return  <div key={inde} class="relative child">
          <span class={`badge badge-pill bg-${statusColor} mr-1`}>
            <p style={{ color: "#fff", fontWeight: "bold" }}> {txnstatus?.id} </p>{" "}
            <p style={{ color: "#fff", fontWeight: "bold" }}>{txnstatus?.count}</p>{" "}
           {`${ruppysymble}${txnstatus?.total}`}
          </span>
          <div class="absolute">
             
            <CircularProgressbar  styles={buildStyles({
                pathColor: statusRailColor,
                textColor: statusRailColor,
                trailColor: "#ccc",
                backgroundColor: "#3e98c7",
              })} value={percentage} text={`${percentage}%`} />
          </div>
        </div>
          }) }
        
        {/* <div class="relative child">
          <span class="badge badge-pill bg-danger mr-1">
            <p style={{ color: "#fff", fontWeight: "bold" }}> {"SUCCESS"} </p>{" "}
            <p style={{ color: "#fff", fontWeight: "bold" }}>{454545}</p>{" "}
            {<br />} {`${ruppysymble}${1000}`}
          </span>
          <div class="absolute">
            <CircularProgressbar
              styles={buildStyles({
                pathColor: `rgba(220, 53, 69, ${percentage / 100})`,
                textColor: "#f88",
                trailColor: "#ccc",
                backgroundColor: "#3e98c7",
              })}
              value={percentage}
              text={`${percentage}%`}
            />
          </div>
        </div> */}
      {/* </div> */}
      <StatusDetails
        transactionStatuswithAmount={transactionStatuswithAmount}
        sumOfallSatus={sumOfallSatus}
      />
      {/* <div className="whole">
        {transactionStatuswithAmount !== null &&
          transactionStatuswithAmount !== undefined &&
          transactionStatuswithAmount.length > 0 &&
          transactionStatuswithAmount.map((txnstatus, inde) => {
            if (txnstatus.id == "SUCCESS") {
              return (
                <span key={inde} class="badge badge-pill bg-success mr-1">
                  {txnstatus?.id}, {txnstatus?.count},{" "}
                  {`${ruppysymble}${txnstatus?.total}`}
                </span>
              );
            } else if (txnstatus?.id == "FAILED") {
              return (
                <span key={inde} class="badge badge-pill bg-danger mr-1">
                  {txnstatus?.id}, {txnstatus?.count},{" "}
                  {`${ruppysymble}${txnstatus?.total}`}
                </span>
              );
            } else if (txnstatus?.id == "PENDING") {
              return (
                <span key={inde} class="badge badge-pill bg-warning mr-1">
                  {txnstatus?.id}, {txnstatus?.count},
                  {`${ruppysymble}${txnstatus?.total}`}
                </span>
              );
            }
          })}
      </div> */}
    </div>
  );
}
